import moment from 'moment';

export const formatDate = (date: number, format: string) => {
  return date > 0
    ? moment(date * 1000)
        .utc()
        .format(format)
    : null;
};
